import { Fix64 } from "../maths/fix64";
import { Cell } from "./cell";

/** Positions along the road. Distance is measured in cells from the spawn centre. */
export function positionAt(road: readonly Cell[], distance: Fix64): [Fix64, Fix64] {
  const last = road.length - 1;
  if (distance.le(Fix64.Zero)) return [Fix64.fromInt(road[0].x), Fix64.fromInt(road[0].y)];
  const index = distance.floorToInt();
  if (index >= last) return [Fix64.fromInt(road[last].x), Fix64.fromInt(road[last].y)];
  const frac = distance.frac();
  const a = road[index], b = road[index + 1];
  return [Fix64.fromInt(a.x).add(Fix64.fromInt(b.x - a.x).mul(frac)), Fix64.fromInt(a.y).add(Fix64.fromInt(b.y - a.y).mul(frac))];
}

export function distanceSquared(ax: Fix64, ay: Fix64, bx: Fix64, by: Fix64): Fix64 {
  const dx = ax.sub(bx), dy = ay.sub(by);
  return dx.mul(dx).add(dy.mul(dy));
}
